import React, { useState, useEffect } from "react";
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  TextField,
  Button,
  CircularProgress,
  Alert,
  Link,
  Stack,
} from "@mui/material";
import axiosInstance from "../../../utils/axiosInstance";

export default function ResetPassword() {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [verifyPassword, setVerifyPassword] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "Reset Password | KlonIT Web Application";
  }, []);

  const handleSubmit = async (event) => {
    event.preventDefault();
    setMessage("");
    setError("");
    setLoading(true);

    if (newPassword !== verifyPassword) {
      setError("New passwords do not match.");
      setLoading(false);
      return;
    }

    if (newPassword.length < 8) {
      setError("New password must be at least 8 characters long.");
      setLoading(false);
      return;
    }

    const formData = {
      currentPassword,
      newPassword,
      verifyPassword,
    };

    try {
      const response = await axiosInstance.post(`/update-user-profile`, formData);
      setMessage(response.data.message || "Password updated successfully!");
      setCurrentPassword("");
      setNewPassword("");
      setVerifyPassword("");
    } catch (err) {
      console.error("Error updating password:", err);
      setError(
        err.response?.data?.message || "An error occurred while updating password."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ maxWidth: 500, mx: "auto", mt: 5 }}>
      <Card elevation={3}>
        <CardHeader
          title="Password"
          titleTypographyProps={{ variant: "h6", fontWeight: 600 }}
          sx={{ pb: 0 }}
        />
        <CardContent>
          <form onSubmit={handleSubmit}>
            <Stack spacing={3}>
              <TextField
                type="password"
                label="Current Password"
                variant="outlined"
                fullWidth
                required
                value={currentPassword}
                onChange={(e) => setCurrentPassword(e.target.value)}
                helperText={
                  <Link href="/forgot-password" target="_blank" underline="hover">
                    Forgot your password?
                  </Link>
                }
              />

              <TextField
                type="password"
                label="New Password"
                variant="outlined"
                fullWidth
                required
                value={newPassword}
                onChange={(e) => setNewPassword(e.target.value)}
              />

              <TextField
                type="password"
                label="Verify Password"
                variant="outlined"
                fullWidth
                required
                value={verifyPassword}
                onChange={(e) => setVerifyPassword(e.target.value)}
              />

              {message && <Alert severity="success">{message}</Alert>}
              {error && <Alert severity="error">{error}</Alert>}

              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={loading}
                sx={{ alignSelf: "flex-start", minWidth: 150 }}
              >
                {loading ? (
                  <>
                    <CircularProgress size={20} sx={{ mr: 1 }} /> Saving...
                  </>
                ) : (
                  "Save Changes"
                )}
              </Button>
            </Stack>
          </form>
        </CardContent>
      </Card>
    </Box>
  );
}
